module.exports = __webpack_public_path__ + "static/media/05_720.d175d673.jpeg";